import { ChangeDetectorRef, Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Editor, EditorModule } from 'primeng/editor';
import { FileUploadModule } from 'primeng/fileupload';
import Quill from 'quill';
import Block from 'quill/blots/block';
import { WhatsappTemplateService } from 'src/app/private/services/whatsapp-template.service';
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { SafeUrlPipe } from 'src/safe-url.pipe';
import { ContactGroupService } from 'src/app/private/services/contact-group.service';



@Component({
  selector: 'app-create-whatsapp-template',
  imports: [SharedModule, FileUploadModule, EditorModule, SafeUrlPipe],
  templateUrl: './create-whatsapp-template.component.html',
  styleUrl: './create-whatsapp-template.component.scss'
})
export class CreateWhatsappTemplateComponent {

  @Output() closeDialog = new EventEmitter<any>();
  @Input() type: string = 'Create';
  @ViewChild('editor') editorComponent!: Editor;
  @Output() reload = new EventEmitter<any>();
  @Input() templateDataToEdit: any;
  @Input() contactGroupColumns: any[] = [];
  @Input() mappingDataToEdit: any = {};


  editorConfig = {
    keyboard: {
      bindings: {
        enter: {
          key: 13,
          shiftKey: false,
          handler: (range: any, context: any) => {
            const quill = context.quill;
            quill.insertText(range.index, '<br/>'); // Inserts <br/> instead of <p>
            quill.setSelection(range.index + 1);
          }
        }
      }
    }
  };


  showMediaThroughMediaID: boolean = false;

  constructor(public cdRef: ChangeDetectorRef,
    private messageService: MessageService,
    private localStorage: LocalStorageService,
    private api: WhatsappTemplateService,
    private contactGroupService: ContactGroupService
  ) {
    Block.tagName = 'DIV'; // Change paragraph tags to <div>
    Quill.register(Block, true); // Register inside the constructor
  }

  variables: { [key: string]: string } = {};
  variableMapping: { [key: string]: string } = {};
  template: any = {
    template_name: '',
    header_text: '',
    category: '',
    language: '',
    labels: '',
    header: 'none',
    body: '',
    footer: '',
    media: '',
    mediaData: ''
  };
  editorData: string = '';
  languages: string[] = ['English', 'Hindi', 'Gujarati'];
  isSubmitted = false;
  languagesList: any[] = [];
  base64Data: string = '';
  mediaId: string = '';

  countQuickReplyButton: number = 0;
  countCTAButtonForURL: number = 0;
  countCTAButtonForCall: number = 0;

  quickReplyButtons: any[] = [];
  urlButtons: any[] = [];
  callButtons: any[] = [];

  headerOptions = [
    { label: 'None', value: 'none' },
    { label: 'Text', value: 'text' },
    { label: 'Media', value: 'media' }
  ];

  mediaOptions = [
    { label: 'Image', value: 'image' },
    { label: 'Video', value: 'video' },
    { label: 'Document', value: 'document' }
  ];

  renderedData: string = '';
  variableError = false;

  urlTypeOptions = [
    { label: 'Static', value: 'static' },
    { label: 'Dynamic', value: 'dynamic' }
  ];

  currentTime: string = '';
  timerId: any;
  showAllVariables = false;
  btnLoading = false;
  templateIDToEdit: string = '';


  ngOnInit() {
    this.updateTime();
    this.timerId = setInterval(() => this.updateTime(), 60000); // Update every minute
    this.getAllLanguages();

    // convert to label and value pair
    this.contactGroupColumns = this.contactGroupColumns.map((column) => ({
      label: this.convertKeyToLabel(column),
      value: column
    }));

    console.log("this.contactGroupColumns", this.contactGroupColumns);

    setTimeout(() => {
      if (this.templateDataToEdit) {
        if (this.type === 'Edit' && this.templateDataToEdit.containerMeta) {
          const { header, body, footer } = this.splitString(this.templateDataToEdit.containerMeta);
          const { quickReplyButtons, urlButtons, callButtons } = this.parseButtons(this.templateDataToEdit.containerMeta);


          this.quickReplyButtons = quickReplyButtons.map((button: string) => ({ value: button }));
          this.urlButtons = urlButtons.map((button: any) => ({
            title: button.text,
            urlType: button.urlType,
            value: button.url,
            suffix: button.suffix
          }));
          this.callButtons = callButtons.map((button: any) => ({ title: button.text, value: button.url }));

          this.countQuickReplyButton = this.quickReplyButtons.length;
          this.countCTAButtonForURL = this.urlButtons.length;
          this.countCTAButtonForCall = this.callButtons.length;

          this.template = {
            template_name: this.templateDataToEdit.elementName,
            header_text: header,
            category: this.templateDataToEdit.category,
            labels: this.templateDataToEdit.vertical,
            body: body,
            footer: footer,
            header: header ? 'text' : 'none',
            language: this.templateDataToEdit.languageCode
          };

          this.templateIDToEdit = this.templateDataToEdit.id;

          console.log("body1123", this.template.body);
          const dataToAddInEditor = this.formateData(this.template.body);

          const quill = this.editorComponent?.quill;

          const metaData = JSON.parse(this.templateDataToEdit.containerMeta);

          console.log("metaData 123 ", metaData);


          this.editorData = dataToAddInEditor;
          // make quill clipboard empty

          quill.clipboard.dangerouslyPasteHTML(0, '');

          console.log("dataToAddInEditor", dataToAddInEditor);

          quill.clipboard.dangerouslyPasteHTML(0, dataToAddInEditor);
          this.renderedData = this.formateData(this.template.body);
          console.log("this.renderedData", this.renderedData);

          if (['IMAGE', 'VIDEO', 'DOCUMENT'].includes(this.templateDataToEdit.templateType)) {
            this.template.header = 'media';
            this.template.media = this.templateDataToEdit.templateType.toLowerCase();
            const data = JSON.parse(this.templateDataToEdit.meta);
            this.mediaId = data.mediaId;
            this.showMediaThroughMediaID = true;
          }

          if (metaData.sampleText) {

            console.log("metaData.sampleText", metaData.sampleText);

            const variablePattern = /\{\{\d+\}\}/g;
            const variablesInText = this.editorData.match(variablePattern);

            if (variablesInText) {
              const uniqueVariables = new Set(variablesInText);
              const variablesArray = Array.from(uniqueVariables);

              if (uniqueVariables.size < this.variableCounter) {
                let start = 1;

                variablesArray.forEach((variable) => {
                  const escapedVariable = variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                  const variablePattern = new RegExp(escapedVariable, 'g');
                  this.editorData = this.editorData.replace(variablePattern, `{{${start}}}`);
                  start++;
                });

                this.variableCounter = start - 1;
              } else {
                this.variableCounter = uniqueVariables.size;
              }
            }

            this.extractVariables();
            this.variables = this.extractAndPopulate(metaData.sampleText);
            
            // Handle variable_mapping if it exists in metaData
            console.log("this.templateDataToEdit.variable_mapping", this.templateDataToEdit);
            if (this.mappingDataToEdit) {
              this.variableMapping = this.mappingDataToEdit;
             
            }
            
            console.log(this.variables);
            console.log("this.renderedData", metaData.sampleText);
            this.renderedData = this.removeBrackets(metaData.sampleText);
            console.log("this.renderedData after removal brackaet", this.renderedData);
            this.cdRef.detectChanges();
          }

          console.log("this.renderedData", this.renderedData);

          console.log("this.template", this.template);

        }
      }
    }, 100);
  }

  // convert key to label by replacing _ with space and capitalizing first letter of each word
  convertKeyToLabel(key: string): string {
    return key
      .replace(/_/g, ' ')
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }

  extractAndPopulate(inputString: string): { [key: string]: string } {
    const matches = inputString.match(/\[([^\]]+)\]/g);
    const result: { [key: string]: string } = {};

    if (matches) {
      matches.forEach((match, index) => {
        result[`{{${index + 1}}}`] = match.replace(/[\[\]]/g, '');  // Remove brackets and assign
      });
    }

    return result;
  }

  removeBrackets(input: string): string {
    let output = input.replace(/\*(.*?)\*/g, '<b>$1</b>');

    // Remove square brackets [] but keep the content inside
    output = output.replace(/\[(.*?)\]/g, '$1');

    // Replace newline characters with <br/>
    output = output.replace(/\n/g, '<br/>');

    return output;
  }

  extractVariables(): void {
    const variablePattern = /\{\{\d+\}\}/g;
    const variablesInText = this.editorData.match(variablePattern);
    const uniqueVariables = new Set(variablesInText);

    // have to trim extra variables key which is not in uniqueVariables
    for (const variable in this.variables) {
      if (!uniqueVariables.has(variable)) {
        delete this.variables[variable];
        delete this.variableMapping[variable]; // Also remove from mapping
      }
    }
    uniqueVariables.forEach(variable => {
      this.variables[variable] = this.variables[variable] || ''; // Use empty string if no value is provided
      // Initialize mapping if not already set
      if (!this.variableMapping[variable]) {
        this.variableMapping[variable] = '';
      }
    });

    this.updateRenderedData();


  }


  formateData(data: any) {

    if (!data) {
      return '';
    }

    return data
      .replace(/\n/g, '<br/>') // Replace \n with <br>
      .replace(/\*(.*?)\*/g, '<b>$1</b>'); // Replace *text* with <b>text</b>
  }

  parseButtons(input: string): {
    quickReplyButtons: string[], urlButtons: { text: string, urlType: string, url: string }[],
    callButtons: { text: string, url: string }[]
  } {

    if (!input) {
      return { quickReplyButtons: [], urlButtons: [], callButtons: [] };
    }

    const quickReplyButtons: string[] = [];
    const urlButtons: {
      text: string, urlType: string, url: string,
      suffix?: string
    }[] = [];
    const callButtons: { text: string, url: string }[] = [];

    // Parse the input string as JSON
    const inputData = JSON.parse(input);

    // Assuming buttons field is present in the input JSON
    const { buttons } = inputData;


    if (buttons) {
      buttons.forEach((button: any) => {
        if (button.type === 'QUICK_REPLY') {
          // Add to quickReplyButtons if type is QUICK_REPLY
          quickReplyButtons.push(button.text.trim());
        } else if (button.type === 'URL') {
          // Add to urlButtons if type is URL

          if (button.url.includes('{{1}}')) {
            const url = button.url.split('{{1}}');
            const suffix = button.example[0].split("/")[3];
            urlButtons.push({ text: button.text.trim(), urlType: "dynamic", url: url[0].trim(), suffix: suffix });
          } else {
            urlButtons.push({ text: button.text.trim(), urlType: "static", url: button.url.trim() });
          }
        } else if (button.type === 'PHONE_NUMBER') {
          // Add to urlButtons if type is URL
          callButtons.push({ text: button.text, url: button.phone_number });
        }
      });
    }

    return { quickReplyButtons, urlButtons, callButtons };
  }

  splitString(inputString: any) {

    if (!inputString) {
      return { header: '', data: '', footer: '' };
    }

    const inputData = JSON.parse(inputString);

    const { header, data: body, footer } = inputData;

    return {
      header: header,
      body: body,
      footer: footer
    };
  }

  ngOnDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const quill = this.editorComponent?.quill;
      console.log(quill.root.innerHTML.trim())
      if (quill) {
        quill.on('text-change', () => {
          const currentContent = quill.root.innerHTML.trim();
          this.updateRenderedData();
          console.log(currentContent);
          // ✅ Only update `this.editorData` when variables are inserted or changed
          //   if (currentContent.trim() !== '<p><br></p>') {
          //     this.editorData = currentContent;
          //     this.onEditorChange();
          // }
          const parser = new DOMParser();
          const doc = parser.parseFromString(currentContent, 'text/html');
          const plainText = doc.body.textContent?.trim() || ''; // Extract plain text
          console.log("plantext", plainText);
          if (plainText?.length > 1 && plainText != '' && plainText != '<br>') {
            this.editorData = currentContent;
            this.onEditorChange();
          } else {
            this.editorData = '';
            this.onEditorChange();
          }
        });
      } else {
        console.error('Quill instance not found.');
      }
    }, 1000);
  }

  handleCloseDialog() {
    this.resetForm();
    this.closeDialog.emit();
  }

  getAllLanguages() {
    // this.api.getAllLanguages().subscribe((res: any) => {
    //   this.languagesList = res;
    // });
    this.languagesList = [
      {
        "id": "1",
        "code": "en",
        "language": "English",
        "createdAt": "2024-09-10T12:07:50.696Z",
        "updatedAt": "2024-09-10T12:07:50.696Z"
      },
      {
        "id": "2",
        "code": "hi",
        "language": "Hindi",
        "createdAt": "2024-09-10T12:08:24.237Z",
        "updatedAt": "2024-09-10T12:08:24.237Z"
      }
    ];
  }

  onSubmit() {
    console.log(this.template);
  }

  selectMedia(mediaType: string) {
    this.template.media = mediaType;
    this.base64Data = '';
    this.template.mediaData = '';
    this.showMediaThroughMediaID = false;
    this.mediaId = '';
  }

  onFileChange(event: any) {
    const file = event.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.template.mediaData = e.target.result;
      };
      reader.readAsDataURL(file);

      const organization_id = this.localStorage.getOrganizationId();

      // Upload the file to the backend API
      this.api.uploadFile(file, organization_id).subscribe(
        (response: any) => {
          console.log('API Response file:', response);
          response = JSON.parse(response || '{}');
          this.mediaId = response.mediaId;
        },
        (error: any) => {
          console.error('Error uploading file:', error);
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to upload media file.' });
        }
      );
    }
  }

  acceptedFileTypes() {
    if (this.template.media === 'image') return 'image/jpeg, image/png';
    if (this.template.media === 'video') return 'video/mp4';
    if (this.template.media === 'document') return 'application/pdf';
    return '';
  }

  maxFileSize() {
    if (this.template.media === 'image' || this.template.media === 'document') return 2 * 1024 * 1024; // 2MB
    if (this.template.media === 'video') return 20 * 1024 * 1024; // 20MB
    return 0;
  }

  removeMedia() {
    this.template.mediaData = '';
    this.showMediaThroughMediaID = false;
    this.template.mediaData = '';
    this.mediaId = '';
  }

  variableCounter = 0;

  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  insertVariable() {
    this.variableCounter++;
    const newVariable = `{{${this.variableCounter}}}`;
    const quill = this.editorComponent.quill; // Access QuillJS instance
    this.variables[newVariable] = ''; // Initialize the variable with an empty string
    this.variableMapping[newVariable] = ''; // Initialize the mapping with empty string
    // Get cursor position or fallback to the last character position (excluding the newline)
    let cursorPosition = quill.getSelection()?.index;

    if (cursorPosition === null || cursorPosition === undefined) {
      cursorPosition = quill.getLength() - 1; // Insert at the end without a new line
    }

    // Insert the variable
    quill.insertText(cursorPosition, newVariable);

    this.updateRenderedData();
    this.cdRef.detectChanges();
  }


  onEditorChange(): void {
    const quill = this.editorComponent?.quill;

    if (!quill) return;

    // ✅ Capture cursor position before content change
    const cursorPosition = quill.getSelection()?.index || 0;

    const variablePattern = /\{\{\d+\}\}/g;
    const variablesInText = this.editorData.match(variablePattern) || [];

    const uniqueVariables = Array.from(new Set(variablesInText));

    const newVariables: { [key: string]: string } = {};
    const newVariableMapping: { [key: string]: string } = {};
    let updatedEditorData = this.editorData; // Work with a copy

    uniqueVariables.forEach((variable, index) => {
      const newVariable = `{{${index + 1}}}`;

      // ✅ Convert variable to a RegExp for multiple replacements
      const escapedVariable = variable.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      const variableRegex = new RegExp(escapedVariable, 'g');

      updatedEditorData = updatedEditorData.replace(variableRegex, newVariable);

      console.log("updatedEditorData", updatedEditorData);
      newVariables[newVariable] = this.variables[variable] || '';
      newVariableMapping[newVariable] = this.variableMapping[variable] || '';
    });

    if (updatedEditorData !== this.editorData) {
      this.editorData = updatedEditorData;

      // ✅ Temporarily disable Quill's events to prevent the cursor jump
      quill.off('text-change');

      // ✅ Update Quill content
      quill.root.innerHTML = this.editorData;

      // ✅ Restore cursor position
      setTimeout(() => {
        quill.setSelection(cursorPosition); // Restore original cursor position
        quill.on('text-change', () => {
          this.editorData = quill.root.innerHTML;
          this.onEditorChange();
        });
      }, 0); // Delay ensures Quill rendering completes
    }

    this.variables = { ...newVariables };
    this.variableMapping = { ...newVariableMapping };
    this.variableCounter = uniqueVariables.length;
    this.updateRenderedData();
    this.cdRef.detectChanges();


  }

  updateRenderedData(): void {
    this.renderedData = this.editorData;
    for (const variable in this.variables) {
      const value = this.variables[variable] || `${variable}`;

      const escapedVariable = variable.replace(/[{}]/g, '\\$&'); // Escape the curly braces
      const regex = new RegExp(escapedVariable, 'g'); // Create a global regular expression
      this.renderedData = this.renderedData.replace(regex, value);
    }

    for (const variable in this.variables) {
      if (this.variables[variable] === '') {
        this.variableError = true;
        return;
      }
    }

    this.variableError = false;
  }


  addQuickReplyButton(event: any): void {
    event.preventDefault();

    if (this.countQuickReplyButton + this.countCTAButtonForCall + this.countCTAButtonForURL > 10) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'You can add maximum 10 buttons in a template.' });
      return
    }

    this.countQuickReplyButton++;

    this.quickReplyButtons.push({
      value: ''
    });

  }

  addUrlButton(event: any): void {

    if (this.countCTAButtonForURL > 1) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'You can add maximum 2 Url Buttons in template' });

      return
    }

    event.preventDefault();
    this.countCTAButtonForURL++;
    this.urlButtons.push({
      value: '',
      title: '',
      urlType: '',
      suffix: '',
    });

  }

  addCallButton(event: any): void {
    event.preventDefault();


    if (this.countCTAButtonForCall > 0) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'You can add maximum 1 Call Button in template' });
      return
    }

    this.countCTAButtonForCall++;
    this.callButtons.push({
      value: ''
    });
  }

  removeQuickReplyButton(event: any, index: any): void {
    event.preventDefault();
    this.countQuickReplyButton--;

    // remover perticular index from array
    this.quickReplyButtons.splice(index, 1);

  }

  removeUrlButton(event: any, index: any): void {
    event.preventDefault();
    this.countCTAButtonForURL--;
    this.urlButtons.splice(index, 1);
  }

  removeCallButton(event: any, index: any): void {
    event.preventDefault();
    this.countCTAButtonForCall--;
    this.callButtons.splice(index, 1);
  }

  updateTime() {
    const now = new Date();
    const hours = now.getHours();
    const minutes = now.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

    this.currentTime = `${formattedHours}:${formattedMinutes} ${ampm}`;
  }


  showAllOptions() {
    this.showAllVariables = !this.showAllVariables;
  }



  handleSubmit(eventForm: any) {
    this.isSubmitted = true;
    if (eventForm.valid) {
      console.log(this.template);
    }
    if (this.isValidForm()) {
      this.btnLoading = true;
      let modifyButtons: any = [];

      this.quickReplyButtons.forEach((button: any) => {
        modifyButtons.push({
          type: 'QUICK_REPLY',
          text: button.value
        });
      });

      this.urlButtons.forEach((button: any) => {


        if (button.urlType === 'static' || button.urlType === '') {
          modifyButtons.push({
            type: 'URL',
            text: button.title,
            url: button.value
          });
        } else if (button.urlType === 'dynamic') {


          // {"type":"URL","text":"visit us","url":"https://gravitas.ai/{{1}}","example":["https://gravitas.ai/about"]}

          modifyButtons.push({
            type: 'URL',
            text: button.title,
            url: button.value + '{{1}}',
            example: [button.value + button.suffix]
          });
        }

      });

      this.callButtons.forEach((button: any) => {
        modifyButtons.push({
          type: 'PHONE_NUMBER',
          text: button.title,
          phone_number: button.value
        });
      });

      let exampleData = this.editorData;

      for (const variable in this.variables) {
        const value = this.variables[variable] || ''; // Use empty string if no value is provided

        const escapedVariable = variable.replace(/[{}]/g, '\\$&'); // Escape the curly braces
        const regex = new RegExp(escapedVariable, 'g'); // Create a global regular expression
        exampleData = this.renderedData.replace(regex, `[${value}]`);
      }



      const payload = {
        organization_id: this.localStorage.getOrganizationId(),
        elementName: this.template.template_name,
        languageCode: this.template.language,
        category: this.template.category,
        template_id: this.templateIDToEdit,
        // for media hve to pass IMage or Video or Document
        templateType: this.template.header === 'text' ? 'TEXT' : this.template.header === 'none' ? 'TEXT' : this.template.media === 'image' ? 'IMAGE' : this.template.media === 'video' ? 'VIDEO' : this.template.media === 'document' ? 'DOCUMENT' : 'LOCATION',
        vertical: this.template.labels,
        content: this.convertHtmlToText(this.editorData),
        header: this.template.header === 'text' ? this.template.header_text : '',
        exampleHeader: this.template.header_text,
        footer: this.template.footer,
        example: this.generateSample(this.editorData),
        enableSample: this.template.header === 'media' ? true : false,
        allowTemplateCategoryChange: false,
        buttons: modifyButtons,
        mediaId: this.template.header === 'media' ? this.mediaId : '',
        variable_mapping: this.variableMapping
      };

      if (this.type === 'Edit') {



        this.api.updateGupshupTemplate(payload).subscribe({
          next: (res: any) => {

            this.btnLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Template updated successfully.' });
            this.resetForm();
            this.reload.emit();
            this.closeDialog.emit();
          },
          error: (err: any) => {
            console.error('Error updating template:', err);
            this.btnLoading = false;
            this.messageService.add({
              severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to create template.'
            });
          },

          complete: () => {
            console.log('Template creation process completed.');
          }
        });
      } else {
        this.api.createWhatsappTemplate(payload).subscribe({
          next: (res: any) => {
            this.btnLoading = false;
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Template created successfully. it will be available for use after approval.' });
            this.resetForm();
            this.reload.emit();
            this.closeDialog.emit();
          },
          error: (err: any) => {
            console.error('Error creating template:', err);
            this.btnLoading = false;
            this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error || 'Failed to create template.' });
          },
          complete: () => {
            console.log('Template creation process completed.');
          }
        });
      }
      // Handle form submission, e.g., send data to the server
    } else {
      console.error('Form submission failed. Please correct the errors.');
    }
  }

  isValidForm(): boolean {

    console.log("this.urlButtons", this.urlButtons);

    // Template names can only contain small letters, numbers and underscores.
    const templateNameValid = this.template.template_name !== '' &&
      /^[a-z0-9_]+$/.test(this.template.template_name);
    const categoryValid = this.template.category !== '';
    const languageValid = this.template.language !== '';
    const labelsValid = this.template.labels !== '';
    const headerValid = this.template.header !== '';
    const bodyValid = this.editorData !== '';

    const header_textValid = this.template.header === 'text' ? this.template.header_text !== '' : true;
    const mediaIdValid = this.template.header === 'media' ? this.mediaId !== '' : true;

    // checking for any variable empty or not 

    for (const variable in this.variables) {
      if (this.variables[variable] === '') {
        this.variableError = true;
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter value in all variables.' });
        return false;
      }
    }


    // checking for value in on quick reply button

    if (this.quickReplyButtons.length > 0) {
      for (let i = 0; i < this.quickReplyButtons.length; i++) {
        if (this.quickReplyButtons[i].value === '') {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter value in quick reply button.' });
          return false;
        }
      }
    }

    // checking for value in on url button

    if (this.urlButtons.length > 0) {
      for (let i = 0; i < this.urlButtons.length; i++) {
        if (this.urlButtons[i].value === '' || this.urlButtons[i].title === '') {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter value in url button.' });
          return false;
        }

        if (this.urlButtons[i].urlType === 'dynamic' && this.urlButtons[i].suffix === '') {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter suffix in url button.' });
          return false;
        }

        // check for value must be url
        if (this.urlButtons[i].urlType === '' && !this.urlButtons[i].value.includes('http')) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter valid url in url button.' });
          return false;
        }

        // check for value must be url

        if (!/^(https?:\/\/)?([\w.-]+)\.([a-z]{2,})([\/\w .-]*)*\/?$/.test(this.urlButtons[i].value)) {

          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Please enter a valid URL in the URL button.'
          });
          return false;
        }


        if (this.urlButtons[i].urlType === 'dynamic' && !this.urlButtons[i].value.includes('http')) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter valid url in url button.' });
          return false;
        }
      }
    }

    // checking for value in on call button

    if (this.callButtons.length > 0) {
      for (let i = 0; i < this.callButtons.length; i++) {
        if (this.callButtons[i].value === '' || this.callButtons[i].title === '') {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please enter value in call button.' });
          return false;
        }
      }
    }

    return templateNameValid && categoryValid && languageValid &&
      labelsValid && headerValid && bodyValid && header_textValid && mediaIdValid;
  }


  convertHtmlToText(html: string): string {
    return html
      .replace(/(<div>.*?<\/div>)/g, '$1\n') // Add '\n' after non-empty <div> content
      .replace(/<\/?div>/g, '') // Remove all <div> tags
      .replace(/<strong>(.*?)<\/strong>/g, '*$1*') // Replace <strong>...</strong> with *...*
      .replace(/<br\s*\/?>/g, '') // Replace <br> with \n
      .replace(/&nbsp;/g, ' '); // Replace &nbsp; with a space

  }

  generateSample(html: string): string {
    console.log("sample html", html);
    const sample = html
      .replace(/(<div>.*?<\/div>)/g, '$1\n') // Add '\n' after non-empty <div> content
      .replace(/<\/?div>/g, '') // Remove all <div> tags
      .replace(/<strong>(.*?)<\/strong>/g, '*$1*') // Replace <strong>...</strong> with *...*
      .replace(/<br\s*\/?>/g, '') // Replace <br> with '\n'
      .replace(/&nbsp;/g, ' '); // Replace &nbsp; with a space

    console.log("sample converted", sample);

    return sample.replace(/{{\d+}}/g, match => {
      return `[${this.variables[match] || match}]`; // If no match is found, return the original placeholder in brackets
    });
  }



  resetForm() {
    this.template = {
      template_name: '',
      header_text: '',
      category: '',
      language: '',
      labels: '',
      header: 'none',
      body: '',
      footer: '',
      media: '',
      mediaData: ''
    }

    this.template.body = '';

    this.editorData = '';
    this.isSubmitted = false;
    this.languagesList = [];
    this.base64Data = '';
    this.mediaId = '';
    this.countQuickReplyButton = 0;
    this.countCTAButtonForURL = 0;
    this.countCTAButtonForCall = 0;
    this.quickReplyButtons = [];
    this.urlButtons = [];
    this.callButtons = [];
    this.renderedData = '';
    this.variables = {};
    this.variableMapping = {};
    this.variableCounter = 0;

    this.templateDataToEdit = null;
    this.showMediaThroughMediaID = false;

    const quill = this.editorComponent?.quill;
    quill.clipboard.dangerouslyPasteHTML(0, '');

    this.showAllVariables = false;

    this.btnLoading = false;

  }

  isValidHeaderText(text: string): boolean {
    const regex = /^[a-zA-Z0-9\s.,!?'()-]+$/;
    return regex.test(text);
  }






}
